import { render, staticRenderFns } from "./TabStep.vue?vue&type=template&id=6fe72933&scoped=true"
import script from "./TabStep.vue?vue&type=script&lang=js"
export * from "./TabStep.vue?vue&type=script&lang=js"
import style0 from "./TabStep.vue?vue&type=style&index=0&id=6fe72933&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe72933",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe72933')) {
      api.createRecord('6fe72933', component.options)
    } else {
      api.reload('6fe72933', component.options)
    }
    module.hot.accept("./TabStep.vue?vue&type=template&id=6fe72933&scoped=true", function () {
      api.rerender('6fe72933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/TabStep.vue"
export default component.exports